module.exports = __webpack_public_path__ + "img/0.d7cb08dd.png";